import * as Yup from 'yup'

import nameValidation from '../../../features/validations/name'

export const validationSchema = Yup.object({
  ...nameValidation
})
